import PropTypes from 'prop-types';
import CourseCard from 'uI/CourseCard/CourseCard';

import classes from './Courses.module.css';

const Courses = props => {
  return (
    <div className={classes.storeContainer}>
      <p className={classes.section}>Cursos</p>
      {props.itemsStore.map(course => (
        <CourseCard key={course.idCourse} itemData={course} />
      ))}
    </div>
  );
};

Courses.propTypes = {
  // eslint-disable-next-line react/require-default-props
  itemsStore: PropTypes.object
};

export default Courses;
